<!-- Header Navigation -->
<app-header></app-header>

<!-- Add spacing below header -->
<div class="mt-4"></div>

<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title text-center mb-4">Your Information</h2>
          <p class="text-muted text-center mb-4">
            This demo runs on a shared account, so we've filled this in with
            made-up details for your visit. Edit them if you like — but please
            don't replace them with your real information.
          </p>
          <div class="d-flex justify-content-end mb-3">
            <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="resetCustomer()"
            >
              <i class="fas fa-user-plus me-2" aria-hidden="true"></i>
              New Demo Customer
            </button>
          </div>

          <form (ngSubmit)="onSubmit()">
            <div class="form-group mb-3">
              <label for="name" class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                [value]="customerForm().name"
                disabled
              />
              <small class="form-text text-muted"
                >For this demo, your name is your session code — it's how your
                data is labelled in New Relic.</small
              >
            </div>

            <div class="form-group mb-3">
              <label for="phone" class="form-label">Phone</label>
              <input
                type="tel"
                class="form-control"
                id="phone"
                [value]="customerForm().phone"
                (input)="updateForm('phone', $any($event.target).value)"
                placeholder="Enter your phone number"
              />
            </div>

            <div class="form-group mb-3">
              <label for="address" class="form-label">Delivery Address *</label>
              <textarea
                class="form-control"
                id="address"
                rows="3"
                [value]="customerForm().address"
                (input)="updateForm('address', $any($event.target).value)"
                placeholder="Enter your delivery address"
                required
              ></textarea>
              <small class="form-text text-muted"
                >This field is required to continue.</small
              >
            </div>

            <div class="d-grid">
              <button
                type="submit"
                class="btn btn-primary btn-lg"
                [disabled]="!isFormValid()"
              >
                Continue to Restaurants
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mb-5">
  <app-nr-callout
    title="Who you are to New Relic"
    [nrql]="userNrql"
    buttonLabel="See your sessions"
    missionId="mission-1"
    tryText="Your sample customer is already filled in above — press Continue to Restaurants."
  >
    Before Angular starts, the browser agent receives your session code as
    <code>demoCode</code> and <code>enduser.id</code>. New Demo Customer updates
    both for subsequent telemetry, and the code is persisted for later page
    loads. A PageView that was already sent is not changed retroactively. Your
    name never goes to the server as an account, only as business data and a
    telemetry attribute. The query below counts the data by your code: one row
    per event type that carries it.
    <app-nr-check
      missionId="mission-1"
      questionId="event-type-count"
      kind="choice"
      question="Open 'See your sessions'. How many event types carry your code so far?"
      [options]="['1', '2', '3 or more']"
      [answer]="eventTypeAnswer"
      proves="Every one of those event types carries your demoCode — that's what makes your data findable in a shared account."
    ></app-nr-check>
  </app-nr-callout>
</div>
